import LineGraph from './LineGraph';

export default LineGraph;
